import React, { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { STATS } from "@/constants/testIds";

const ITEMS = [
  { key: "shows", value: 80, suffix: "+", label: "Spectacles réalisés", caption: "depuis 2023" },
  { key: "viewers", value: 50, suffix: "K+", label: "Spectateurs émerveillés", caption: "France · Europe · Maroc" },
  { key: "satisfaction", value: 100, suffix: "%", label: "Satisfaction client", caption: "Note moyenne 5.0/5" },
];

const Counter = ({ to, suffix, active }) => {
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!active) return;
    let raf;
    const start = performance.now();
    const dur = 1600;
    const step = (t) => {
      const p = Math.min(1, (t - start) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.round(eased * to));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [active, to]);
  return (
    <span>
      {n}
      <span className="text-[#007AFF]">{suffix}</span>
    </span>
  );
};

export const Stats = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-20%" });

  return (
    <section
      id="stats"
      data-testid={STATS.root}
      ref={ref}
      className="relative py-28 md:py-32"
    >
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent" />
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid gap-10 md:grid-cols-3 md:gap-12">
          {ITEMS.map((it, idx) => (
            <motion.div
              key={it.key}
              data-testid={STATS.item(it.key)}
              initial={{ opacity: 0, y: 24, filter: "blur(8px)" }}
              animate={inView ? { opacity: 1, y: 0, filter: "blur(0)" } : {}}
              transition={{ duration: 0.8, delay: idx * 0.15 }}
              className="flex flex-col"
            >
              <div className="font-display text-6xl md:text-7xl lg:text-8xl font-light tracking-tighter">
                <Counter to={it.value} suffix={it.suffix} active={inView} />
              </div>
              <div className="mt-4 h-px w-12 bg-[#007AFF]" />
              <p className="mt-4 font-display text-lg font-medium">{it.label}</p>
              <p className="text-sm text-white/50 mt-1">{it.caption}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
